export const TECH_STATUS_TYPES = {
  em_servico: { label: 'Em serviço', color: '#0B7A44', dot: '#0EA65C' },
  deslocamento: { label: 'Deslocamento', color: '#1E4FB8', dot: '#3169E0' },
  almoco: { label: 'Em almoço', color: '#f43f5e', dot: '#fb7185' },
  finalizado: { label: 'Finalizado', color: '#1F7A5C', dot: '#1F9A73' },
  ocioso: { label: 'Ocioso', color: '#B8402F', dot: '#E15B4C' },
  nao_alocado: { label: 'Não alocado', color: '#93700F', dot: '#D6A319' }
};

export function getTechnicianDisplayStatus(tec, isLive) {
  if (!tec) return 'ocioso';
  if (isLive) return tec.status || 'ocioso';
  if (tec.status === 'nao_alocado') return 'nao_alocado';
  if ((tec.osCount || 0) > 0 || (tec.activities?.length || 0) > 0) return 'finalizado';
  return 'ocioso';
}

export function statusSortRank(status) {
  if (status === 'em_servico') return 0;
  if (status === 'deslocamento') return 1;
  if (status === 'almoco') return 2;
  if (status === 'finalizado') return 3;
  return 4;
}
